const defaultHeaderSettings = {
  headerBackTitle: null,
  gesturesEnabled: false,
  headerShown: true,
  headerStyle: {
    shadowColor: 'transparent',
    elevation: 0,
  },
}

export default defaultHeaderSettings
